import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"block"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"margin-right":"10px"} }

import {ref} from "vue";
import {notify} from "@kyvg/vue3-notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'VAPopconfirm',
  props: {
  // 确定消息值，比如要删除，输入删除才能操作
  value: {
    type: String,
    default: ""
  },
  label: {
    type: String,
    required: true,
  },
  labelColor: {
    type: String,
  },
  placeholder: {
    type: String,
    default: "确定操作吗?"
  },
  title: {
    type: String,
    default: "操作"
  },
  okText: {
    type: String,
    default: "确定"
  },
  size: {
    type: String,
    default: "small"
  },
  type: {
    type: String,
    default: "a"
  },
  buttonType: {
    type: String,
  }
},
  emits: ["on-ok"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const visible = ref(false)
const confirmValue = ref("")

const onOk = () => {
  if (confirmValue.value !== props.value) {
    notify({type: 'warn', text: `请输入${props.value}删除`})
    return
  }
  emit("on-ok")
  visible.value = false
  confirmValue.value = ""
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createBlock(_component_a_popconfirm, {
    "cancel-text": "取消",
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event))
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1),
      (__props.value !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_a_input, {
              value: confirmValue.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((confirmValue).value = $event)),
              placeholder: __props.placeholder,
              size: "small"
            }, null, 8, ["value", "placeholder"])
          ]))
        : _createCommentVNode("", true)
    ]),
    okButton: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        size: "small",
        onClick: onOk
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.okText), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        (__props.type === 'a')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              style: _normalizeStyle('color: ' + __props.labelColor)
            }, _toDisplayString(__props.label), 5))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              size: __props.size,
              type: __props.buttonType
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.label), 1)
              ]),
              _: 1
            }, 8, ["size", "type"]))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})